// src/components/Footer.jsx

import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#0a0a0a', borderTop: '1px solid rgba(255,255,255,0.06)', marginTop: 80 }}>

      {/* Main footer content */}
      <div style={{ maxWidth: 960, margin: '0 auto', padding: '56px 24px 40px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 40 }}>

          {/* Brand */}
          <div style={{ gridColumn: 'span 1' }}>
            <Link to="/" style={{ textDecoration: 'none', display: 'inline-block', marginBottom: 14 }}>
              <span style={{ fontSize: 20, fontWeight: 800, color: '#fff', letterSpacing: '-0.5px' }}>
                The<span style={{ color: '#10b981' }}>TradeClass</span>
              </span>
            </Link>
            <p style={{ fontSize: 13, color: '#4b5563', lineHeight: 1.8, marginBottom: 20 }}>
              Learn stock market trading from zero. Free structured lessons for beginners worldwide.
            </p>
            <a href="mailto:info@thetradeclass.com"
              style={{ fontSize: 12, color: '#6b7280', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}
              onMouseEnter={e => e.currentTarget.style.color = '#10b981'}
              onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}>
              ✉ info@thetradeclass.com
            </a>
          </div>

          {/* Learn */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 16 }}>
              Learn
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[
                { to: '/modules',  label: 'All Modules'  },
                { to: '/glossary', label: 'Glossary'     },
                { to: '/pricing',  label: 'Pricing'      },
                { to: '/blog', label: 'Blog' }
              ].map(item => (
                <Link key={item.to} to={item.to}
                  style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none', transition: 'color 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                  onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}>
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 16 }}>
              Legal
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[
                { to: '/disclaimer', label: 'Disclaimer'       },
                { to: '/terms',      label: 'Terms of Service' },
                { to: '/privacy',    label: 'Privacy Policy'   },
                { to: '/refund',     label: 'Refund Policy'    },
              ].map(item => (
                <Link key={item.to} to={item.to}
                  style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none', transition: 'color 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                  onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}>
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Support */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 16 }}>
              Support
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <a href="mailto:info@thetradeclass.com"
                style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}>
                Contact Us
              </a>
              <Link to="/refund"
                style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}>
                Get a Refund
              </Link>
              <Link to="/pricing"
                style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}>
                Pricing
              </Link>
            </div>
          </div>

        </div>
      </div>

      {/* Risk disclaimer */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.04)' }}>
        <div style={{ maxWidth: 960, margin: '0 auto', padding: '20px 24px' }}>
          <p style={{ fontSize: 11, color: '#374151', lineHeight: 1.8, margin: 0 }}>
            <strong style={{ color: '#4b5563' }}>⚠️ Risk Disclaimer: </strong>
            Trading financial instruments involves substantial risk of loss and is not suitable for all investors.
            All content on TheTradeClass is provided for educational purposes only and does not constitute
            financial advice. Past performance is not indicative of future results.
            Never invest money you cannot afford to lose.
          </p>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.04)', backgroundColor: 'rgba(0,0,0,0.3)' }}>
        <div style={{ maxWidth: 960, margin: '0 auto', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
          <span style={{ fontSize: 12, color: '#374151' }}>
            © {new Date().getFullYear()} TheTradeClass · All rights reserved
          </span>
          <div style={{ display: 'flex', gap: 20 }}>
            {[
              { to: '/disclaimer', label: 'Disclaimer' },
              { to: '/terms',      label: 'Terms'      },
              { to: '/privacy',    label: 'Privacy'    },
              { to: '/refund',     label: 'Refund'     },
            ].map(l => (
              <Link key={l.to} to={l.to}
                style={{ fontSize: 11, color: '#374151', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = '#6b7280'}
                onMouseLeave={e => e.currentTarget.style.color = '#374151'}>
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

    </footer>
  );
}